/**
 * Builds the script that hands streaming status to the chat dock.
 *
 * Destinations carry socket-supplied values (e.g. broadcast_id), so pass
 * them as JSON literals. Never wrap them in a string or template literal.
 */
export const buildStreamingStatusScript = (
  isLive: boolean,
  destinations: DestinationPlatformWithLiveInfo[],
) =>
  `window.consumeStreamingStatus(${JSON.stringify(isLive)}, ${JSON.stringify(destinations)})`;
